import React, { useState } from 'react';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { menus } from './Common/Consts/sidebar';
import { Perfil } from './Perfil/Perfil';
import { Hospitalization } from './Hospitalization/Hospitalization';
import { UTI } from './UTI/UTI';
import { Procedures } from './Procedures/Procedures';
import { Discharge } from './Discharge/Discharge';
import { Revenue } from './Revenue/Revenue';
import AIH from './AIH/AIH';
import { HomeNav } from '../Common/Home/HomeNav';

function DashBoardSihSus() {
    const queryClient = new QueryClient();
    const [activeIndex, setActiveIndex] = useState(1);

    const renderPage = (index) => {
        switch (index) {
            case 1:
                return <AIH setActiveIndex={setActiveIndex} />;
            case 2:
                return <Perfil setActiveIndex={setActiveIndex} />;
            case 4:
                return <Hospitalization setActiveIndex={setActiveIndex} />;
            case 3:
                return <UTI setActiveIndex={setActiveIndex} />;
            case 5:
                return <Revenue setActiveIndex={setActiveIndex} />;
            case 6:
                return <Procedures setActiveIndex={setActiveIndex} />;
            case 7:
                return <Discharge setActiveIndex={setActiveIndex} />;
            default:
                return <AIH setActiveIndex={setActiveIndex} />;
        }
    };

    return (
        <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools initialIsOpen={false} />
            <HomeNav
                menus={menus}
                setActiveIndex={setActiveIndex}
                activeIndex={activeIndex}
            />
            <div>{renderPage(activeIndex)}</div>
        </QueryClientProvider>
    );
}

export default DashBoardSihSus;
